











import { Component, Prop, Vue } from 'vue-property-decorator'
import { LocaleMessage } from 'vue-i18n'

export interface Item {
  school: string
  diploma: string|LocaleMessage
  date: string|LocaleMessage
}

@Component({
  name: 'Education'
})
export default class Education extends Vue {
  $mq: any
  delays: number[]

  constructor () {
    super()
    this.delays = []
  }

  get items () {
    return [
      {
        school: 'Epitech (France)',
        diploma: this.$t('educations.epitech.diploma'),
        date: this.$t('educations.epitech.date')
      },
      {
        school: 'California State University Long Beach (USA)',
        diploma: this.$t('educations.csulb.diploma'),
        date: this.$t('educations.csulb.date')
      }
    ]
  }

  mounted () {
    Vue.set(this, 'delays', new Array(this.items.length).fill(300))
  }

  resetDelays () {
    for (const i in this.delays) {
      Vue.set(this.delays, i, 300)
    }
  }

  revealItems () {
    const items = this.items ? this.items.length : 0
    let sum = 0
    let j = 0
    for (const i in this.items) {
      sum += this.delays[i]
      setTimeout(() => {
        Vue.set(this.delays, i, 0)
      }, sum)
    }
  }

  visibilityChanged (isVisible: boolean, entry: any) {
    if (isVisible) {
      this.revealItems()
    } else if (entry.boundingClientRect.top >= 0) {
      this.resetDelays()
    }
  }
}
